import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const ParentPaymentTypesRedux = createActions(
  {
    // Custom actions
    getParentPaymentRequest: ['centerId'],
    getParentPaymentSuccess: ['results'],
    getParentPaymentError: ['error'],
  },
  {
    prefix: 'PARENT_PAYMENT_TYPES_',
    defaultActions: {
      get: true,
    },
  },
)

const getParentPaymentRequest = state =>
  state.merge({ get: { fetching: true, error: null } }, d)

const getParentPaymentSuccess = (state, { results }) =>{
  const item={
    id:0,
    country_id:1,
    type:{
      id:0,
      name:'Seleccione',
    },
    payment_typeable_id:0
  }
  results.unshift(item);
  return state.merge({ get: { fetching: false, error: null, results } }, d)
}

const getParentPaymentError = (state, { error }) =>
  state.merge({ get: { fetching: false, error } }, d)


const { Types, Creators } = ParentPaymentTypesRedux
export const ParentPaymentTypesTypes = Types
export default Creators

export const INITIAL_STATE = createState({
// custom state
},
{
  get: true,
  // Default state
})

export const reducer = createReducer(
  INITIAL_STATE, {
    // custom reducers
    [Types.getParentPaymentRequest]: getParentPaymentRequest,
    [Types.getParentPaymentSuccess]: getParentPaymentSuccess,
    [Types.getParentPaymentError]: getParentPaymentError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ParentPaymentTypesRedux.js